import { motion } from "framer-motion";

export default function TopBar({ onNav }) {
  return (
    <motion.header
      data-testid="top-bar"
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.4, duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-[60] flex items-center justify-between px-5 sm:px-8 py-4"
      style={{
        background: "linear-gradient(to bottom, rgba(14,12,10,0.9), rgba(14,12,10,0))",
      }}
    >
      <button
        data-testid="nav-bharat"
        onClick={() => onNav("atlas")}
        className="font-display text-sm sm:text-base tracking-[0.3em] uppercase text-[#E8DCC4] hover:text-[#C5A059] transition-colors duration-500"
      >
        Bharat
      </button>

      <nav className="flex items-center gap-5 sm:gap-9">
        <button
          data-testid="nav-explore"
          onClick={() => onNav("explore")}
          className="nav-link font-nav text-[10px] sm:text-[11px] uppercase text-[#B8A795]"
        >
          Explore
        </button>
        <button
          data-testid="nav-view-all"
          onClick={() => onNav("viewall")}
          className="nav-link font-nav text-[10px] sm:text-[11px] uppercase text-[#B8A795]"
        >
          View All
        </button>
        <button
          data-testid="nav-master-plan"
          onClick={() => onNav("plan")}
          className="nav-link font-nav text-[10px] sm:text-[11px] uppercase text-[#B8A795]"
        >
          Master Plan
        </button>
        <button
          data-testid="nav-about"
          onClick={() => onNav("about")}
          className="nav-link font-nav text-[10px] sm:text-[11px] uppercase text-[#B8A795]"
        >
          About
        </button>
      </nav>
    </motion.header>
  );
}
